import { Box, Typography } from '@mui/material'
import notShow from 'assets/branch/setting/operative.png'
import show from 'assets/branch/setting/operativeColor.png'
import { OPERATIVE_COLOR } from 'constants/status'
import { useTranslation } from 'react-i18next'

const OpShowOperativeColor = () => {
    const { t } = useTranslation()
    const optionOperativeColor = [
        {
            name: t('BRANCH.TAB.SENTTING.PATTERN_OPERATIVE_COLOR.SHOW'), value: OPERATIVE_COLOR.SHOW,
            component: <OperativeColor showType='1' />,
        },
        {
            name: t('BRANCH.TAB.SENTTING.PATTERN_OPERATIVE_COLOR.NOT_SHOW'), value: OPERATIVE_COLOR.NOT_DISPLAYED,
            component: <OperativeColor showType='0' />,
        }
    ]
    return (optionOperativeColor)
}

export default OpShowOperativeColor

interface ShowOperativeColorProps {
    showType: '0' | '1'
}
const OperativeColor = (props: ShowOperativeColorProps) => {
    const { showType } = props
    const { t } = useTranslation()

    return (
        <Box display='flex' flexDirection='column' gap='16px' height='100%'>
            <Box marginBottom={showType === '0' ? '0px' : '16px'}>
                <Typography fontSize={'20px'} fontWeight={'500'} marginBottom={showType === '1' ? '0px' : '8px'}>
                    {t('BRANCH.TAB.SENTTING.OPERATIVE_COLOR')}
                </Typography>
            </Box>
            <Box display='flex' alignItems={'center'} gap={'16px'} flexDirection={'column'} >
                <Box textAlign='center' sx={{ img: { width: '80%' } }}>
                    <img src={showType === '0' ? notShow : show} alt="" />
                </Box>
            </Box>
            <Box>
                <Typography fontSize={'16px'} fontWeight={'500'} marginBottom='8px'>
                    {t(`BRANCH.TAB.SENTTING.PATTERN_OPERATIVE_COLOR.${showType === '1' ? 'SHOW' : 'NOT_SHOW'}`)}
                </Typography>
                <Typography fontWeight={'400'} paddingLeft='16px' color='#5A5A5A'>
                    {t(`BRANCH.TAB.SENTTING.PATTERN_OPERATIVE_COLOR.SUB_${showType === '1' ? 'SHOW' : 'NOT_SHOW'}`)}
                </Typography>
            </Box>
        </Box>
    )
}